import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { unwrapPagedList } from './paged-list';
import { ContainerUse, ContainerUseSearchRequest } from '../../shared/models/container-use';

@Injectable({ providedIn: 'root' })
export class ContainerUseService {
  constructor(private readonly http: HttpClient) {}

  search(request: ContainerUseSearchRequest = { Page: 1, PageSize: 50 }) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/ContainerUseListSearch`, request).pipe(
      map(raw => unwrapPagedList<ContainerUse>(raw))
    );
  }
}
